<template>
  <div :id="chartId" style="height: 300px; width: 100%;" />
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import * as echarts from 'echarts';

import { Nullable } from '@/utils/types';
import { IVisualizationDataItem } from '@/bundles/Visualizations/interfaces/IVisualizationDataItem';

interface IEChartBar {
  myChart: Nullable<echarts.ECharts>;
}

export default Vue.extend({
  name: 'EChartBar',

  props: {
    chartId: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    chartData: {
      type: Array as PropType<IVisualizationDataItem[]>,
      required: true
    },
  },

  data: (): IEChartBar => ({
    myChart: null,
  }),

  watch: {
    chartData: {
      handler () {
        this.loadChart();
      },
      deep: true,
    }
  },

  mounted () { // can't be moved to watch because it will be called before mounted
    this.loadChart();
  },

  methods: {
    loadChart () {
      const container = document.getElementById(this.chartId);

      if (!container) {
        return;
      }

      if (!this.myChart) {
        this.myChart = echarts.init(container);
      }

      // 120 is approximately the width of the y-axis labels
      const xLabelMaxWidth = this.chartData.length > 5 ? 1000 : (this.myChart.getWidth() - 120) / this.chartData.length;

      this.myChart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            data: this.chartData.map((item) => item.name),
            axisLabel: {
              interval: 0, // show all labels
              overflow: 'break',
              width: xLabelMaxWidth,
              rotate: this.chartData.length > 5 ? 45 : 0,
            },
          },
          yAxis: [
            { type: 'value' }
          ],
          series: [
            {
              name: 'Direct',
              type: 'bar',
              barWidth: '60%',
              data: this.chartData,
              tooltip: {
                valueFormatter: this.chartData.find((item) => item.tooltip?.valueFormatter)?.tooltip?.valueFormatter
              }
            }
          ]
        },
        true
      );
    }
  }
})
</script>
